
    import Vue from "vue";
    import Component from "vue-class-component";
    import HeadingWave from "@/features/shared/components/HeadingWave.vue";
    import SectionPageHeading from "@/features/shared/components/sections/SectionPageHeading.vue";
    import userInfo from "@/features/shared/components/UserInfo";
    import { Prop } from "vue-property-decorator";
    import { NavigationGuardNext } from "vue-router/types/router";
    import ConcessionPermitTypeTable from "../components/ConcessionPermitTypeTable.vue";

    interface Props {
        seafarerId: string;
    }

    @Component({
        components: {
            HeadingWave,
            SectionPageHeading,
            ConcessionPermitTypeTable
        },
        beforeRouteEnter(to, from, next: NavigationGuardNext<NewConcessionPermitApplication>) {
            const props = to.meta!.props as Props;
            props.seafarerId = to.params.seafarerId || userInfo.seafarerId;
            if (!props.seafarerId)
                next(new Error("No seafarer."));
            next();
        }
    })
    export default class NewConcessionPermitApplication extends Vue implements Props {
        @Prop({ required: true })
        seafarerId!: string;
    }
